import React from "react";
import { Box, Typography } from "@mui/material";

const Footer = () => {
    return (
        <Box
            sx={{
                height: '45vh',
                width: '100%',
                position: 'relative',
                overflow: 'hidden',
            }}
        >
            <Box
                sx={{
                    position: 'relative',
                    width: '96vw',
                    maxWidth: '1400px',
                    height: '70vh',
                    maxHeight: '320px',
                    margin: '2vh auto 0',
                    zIndex: 2,
                }}
            >
                <img
                    src="/Images/footerimage1.png"
                    alt="footer"
                    style={{
                        borderRadius: 10,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                    }}
                />
                <Box
                    sx={{
                        position: 'absolute',
                        top: '47%',
                        left: { xs: '50px', md: '80px', lg: '20px' },
                        transform: 'translateY(-50%)',
                        width: { xs: '85%', md: '60%', lg: '100%' },
                        maxWidth: '800px',
                        zIndex: 3,
                    }}
                >
                    <img src="/Images/customersupport.png" alt="customer" height="50px" style={{ borderRadius: 8 }}/>
                    <Typography
                        sx={{
                            color: 'white',
                            fontSize: { xs: '2.5rem', md: '3.5rem', lg: '3.5rem' },
                            fontWeight: 'bold',
                            lineHeight: 1.1,
                            marginBottom: '10px',
                            marginLeft: 6
                        }}
                    >
                        Ready to take the next step
                        <br />
                        in your college journey?
                    </Typography>

                    <Typography
                        sx={{
                            color: 'white',
                            fontSize: { xs: '1rem', md: '1.1rem', lg: '1rem' },
                            fontWeight: 'bold',
                            lineHeight: 1.5,
                            marginBottom: '30px',
                            marginLeft: 6
                        }}
                    >
                        Discover how Dream College Path services can help you plan smarter, stay on track, and move closer to your dream college with confidence.
                    </Typography>
                </Box>
            </Box>
        </Box>
    )
}

export default Footer;